import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row, Space } from 'antd';
import Headline from '../UI/Headline/Headline';

const Instruction = () => {
  const { t } = useTranslation();

  return (
    <Space direction='vertical'>
      <div style={{ marginBottom: 60, marginTop: 150 }}>
        <Headline>{t('pages.main.instruction.title')}</Headline>
      </div>
      <h4 style={{ marginBottom: 40 }}>{t('pages.main.instruction.text')}</h4>
      <Space size={20} direction='vertical'>
        <Row gutter={[20, 20]}>
          <Col xs={24} sm={24} md={24} xl={8} xxl={8}>
            <Space
              direction='vertical'
              style={{
                backgroundColor: '#B8B5B633',
                padding: '40px 40px 80px',
                borderRadius: 30,
                height: '100%',
                width: '100%'
              }}
            >
              <h2 style={{ color: '#9989C7', marginBottom: 8 }}>
                {t('pages.main.instruction.step1.title')}
              </h2>
              <h3 style={{ color: '#584271', marginBottom: 32 }}>
                {t('pages.main.instruction.step1.subtitle')}
              </h3>
              <Space direction='vertical'>
                <ul>
                  <Space align='start'>
                    <p>•</p>
                    <li>{t('pages.main.instruction.step1.text1')}</li>
                  </Space>
                  <Space align='start'>
                    <p>•</p>
                    <li>{t('pages.main.instruction.step1.text2')}</li>
                  </Space>
                </ul>
              </Space>
            </Space>
          </Col>
          <Col xs={24} sm={24} md={24} xl={8} xxl={8}>
            <Space
              direction='vertical'
              style={{
                backgroundColor: '#B8B5B633',
                padding: '40px 40px 80px',
                borderRadius: 30,
                height: '100%'
              }}
            >
              <h2 style={{ color: '#9989C7', marginBottom: 8 }}>
                {t('pages.main.instruction.step2.title')}
              </h2>
              <h3 style={{ color: '#584271', marginBottom: 32 }}>
                {t('pages.main.instruction.step2.subtitle')}
              </h3>
              <Space direction='vertical'>
                <ul>
                  <Space align='start'>
                    <p>•</p>
                    <li>{t('pages.main.instruction.step2.text1')}</li>
                  </Space>
                  <Space align='start'>
                    <p>•</p>
                    <li>{t('pages.main.instruction.step2.text2')}</li>
                  </Space>
                  <Space align='start'>
                    <p>•</p>
                    <li>{t('pages.main.instruction.step2.text3')}</li>
                  </Space>
                </ul>
              </Space>
            </Space>
          </Col>
          <Col xs={24} sm={24} md={24} xl={8} xxl={8}>
            <Space
              direction='vertical'
              style={{
                backgroundColor: '#B8B5B633',
                padding: '40px 40px 80px',
                borderRadius: 30,
                height: '100%'
              }}
            >
              <h2 style={{ color: '#9989C7', marginBottom: 8 }}>
                {t('pages.main.instruction.step3.title')}
              </h2>
              <h3 style={{ color: '#584271', marginBottom: 32 }}>
                {t('pages.main.instruction.step3.subtitle')}
              </h3>
              <Space direction='vertical'>
                <ul>
                  <Space align='start'>
                    <p>•</p>
                    <li>{t('pages.main.instruction.step3.text1')}</li>
                  </Space>
                  <Space align='start'>
                    <p>•</p>
                    <li>{t('pages.main.instruction.step3.text2')}</li>
                  </Space>
                  <Space align='start'>
                    <p>•</p>
                    <li>{t('pages.main.instruction.step3.text3')}</li>
                  </Space>
                  <Space align='start'>
                    <p>•</p>
                    <li>{t('pages.main.instruction.step3.text4')}</li>
                  </Space>
                </ul>
              </Space>
            </Space>
          </Col>
        </Row>
        <Row gutter={[20, 20]}>
          <Col xs={24} sm={24} md={24} xl={8} xxl={8}>
            <Space
              direction='vertical'
              style={{
                backgroundColor: '#B8B5B633',
                padding: '40px 40px 80px',
                borderRadius: 30,
                height: '100%'
              }}
            >
              <h2 style={{ color: '#9989C7', marginBottom: 8 }}>
                {t('pages.main.instruction.step41.title')}
              </h2>
              <h3 style={{ color: '#484271', marginBottom: 32 }}>
                {t('pages.main.instruction.step41.subtitle')}
              </h3>
              <Space direction='vertical'>
                <ul>
                  <Space align='start'>
                    <p>•</p>
                    <li>{t('pages.main.instruction.step41.text1')}</li>
                  </Space>
                  <Space align='start'>
                    <p>•</p>
                    <li>{t('pages.main.instruction.step41.text2')}</li>
                  </Space>
                  <Space align='start'>
                    <p>•</p>
                    <li>{t('pages.main.instruction.step41.text3')}</li>
                  </Space>
                </ul>
              </Space>
            </Space>
          </Col>
          <Col xs={24} sm={24} md={24} xl={8} xxl={8}>
            <Space
              direction='vertical'
              style={{
                backgroundColor: '#B8B5B633',
                padding: '40px 40px 80px',
                borderRadius: 30,
                height: '100%'
              }}
            >
              <h2 style={{ color: '#9989C7', marginBottom: 8 }}>
                {t('pages.main.instruction.step42.title')}
              </h2>
              <h3 style={{ color: '#584271', marginBottom: 32 }}>
                {t('pages.main.instruction.step42.subtitle')}
              </h3>
              <Space direction='vertical'>
                <ul>
                  <Space align='start'>
                    <p>•</p>
                    <li>{t('pages.main.instruction.step42.text1')}</li>
                  </Space>
                  <Space align='start'>
                    <p>•</p>
                    <li>{t('pages.main.instruction.step42.text2')}</li>
                  </Space>
                  <Space align='start'>
                    <p>•</p>
                    <li>{t('pages.main.instruction.step42.text3')}</li>
                  </Space>
                </ul>
              </Space>
            </Space>
          </Col>
          <Col xs={24} sm={24} md={24} xl={8} xxl={8}>
            <Space
              direction='vertical'
              style={{
                backgroundColor: '#B8B5B633',
                padding: '40px 40px 80px',
                borderRadius: 30,
                height: '100%'
              }}
            >
              <h2 style={{ color: '#9989C7', marginBottom: 8 }}>
                {t('pages.main.instruction.step43.title')}
              </h2>
              <h3 style={{ color: '#584271', marginBottom: 32 }}>
                {t('pages.main.instruction.step43.subtitle')}
              </h3>
              <Space direction='vertical'>
                <ul>
                  <Space align='start'>
                    <p>•</p>
                    <li>{t('pages.main.instruction.step43.text1')}</li>
                  </Space>
                  <Space align='start'>
                    <p>•</p>
                    <li>{t('pages.main.instruction.step43.text2')}</li>
                  </Space>
                </ul>
              </Space>
            </Space>
          </Col>
        </Row>
        <Row gutter={[20, 20]}>
          <Col xs={24} sm={24} md={24} xl={8} xxl={8}>
            <Space
              direction='vertical'
              style={{
                backgroundColor: '#B8B5B633',
                padding: '40px 40px 80px',
                borderRadius: 30,
                height: '100%'
              }}
            >
              <h2 style={{ color: '#9989C7', marginBottom: 8 }}>
                {t('pages.main.instruction.step5.title')}
              </h2>
              <h3 style={{ color: '#584271', marginBottom: 32 }}>
                {t('pages.main.instruction.step5.subtitle')}
              </h3>
              <Space direction='vertical'>
                <ul>
                  <Space align='start'>
                    <p>•</p>
                    <li>{t('pages.main.instruction.step5.text1')}</li>
                  </Space>
                  <Space align='start'>
                    <p>•</p>
                    <li>{t('pages.main.instruction.step5.text2')}</li>
                  </Space>
                </ul>
              </Space>
            </Space>
          </Col>
        </Row>
      </Space>
    </Space>
  );
};

export default Instruction;
